module.exports = __webpack_public_path__ + "static/media/FACE JOCKEY PULLEY ( BIN 17069) FOR SDS 900-1200 MACHINES.76f33f24.jpg";